import React from 'react'
import './Checkbox.css'

// Extra props (name, aria-label, ...) go to the native input.
export const Checkbox = ({ checked, onChange, label, disabled = false, ...inputProps }) => {
    return (
        <label className={`checkbox-option checkbox-ios-checkbox ${disabled ? "checkbox-disabled" : ""}`}>
            <input
                type="checkbox"
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                {...inputProps}
            />
            <div className="checkbox-checkbox-wrapper" aria-hidden="true">
                <div className="checkbox-checkbox-bg"></div>
                <svg fill="none" viewBox="0 0 24 24" className="checkbox-checkbox-icon">
                    <path
                        strokeLinejoin="round"
                        strokeLinecap="round"
                        strokeWidth="3"
                        stroke="currentColor"
                        d="M4 12L10 18L20 6"
                        className="checkbox-check-path"
                    />
                </svg>
            </div>
            {label}
        </label>
    );
}


